// Lightweight pub-sub: "the package list may be stale, re-fetch if you care".
// Fired once per upload, when the backend transitions to READY_TO_UPLOAD_TO_PROVIDER -
// that's the moment server-side assembly is complete and the user-perceived "upload"
// step is done. Earlier signals (init created, client-side bytes finished) were too
// noisy and didn't match what users mean by "finished"; later stages (provider transfer,
// CatDV, publish) are bookkeeping the list doesn't need to track in real time.
// Subscribers (package list components) just re-fetch with their current filters.
const listeners = new Set();
const completedUploadIds = new Set();

export const subscribeUploadCompletion = (listener) => {
  if (typeof listener !== "function") return () => {};
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const notifyUploadCompleted = ({ uploadId, status } = {}) => {
  if (uploadId) {
    if (completedUploadIds.has(uploadId)) {
      return false;
    }
    completedUploadIds.add(uploadId);
  }

  listeners.forEach((listener) => {
    try {
      listener({ uploadId, status });
    } catch (err) {
      // Listener errors must not break the SSE handler that called us.
      console.warn("[uploadCompletionEvents] listener threw", err);
    }
  });

  return true;
};

export const __resetUploadCompletionEventsForTest = () => {
  completedUploadIds.clear();
};